import { OrganizationScope } from '../graphql/types';
import { OrganizationMember, useCurrentUser } from './useCurrentUser';

export const useCompanyMembers = (companyId: string): OrganizationMember[] => {
  const { user } = useCurrentUser();
  const organization = user?.organization;

  const members =
    organization?.members.filter((member) => {
      // If the member's organizationScope is OrganizationAdmin, include it in the array
      if (member.organizationScope === OrganizationScope.OrganizationAdmin) {
        return true;
      }

      // If not, check if scope has the current company id and include if so
      return member.companyScopes.some((scope) => scope.companyId === companyId);
    }) || [];

  return members;
};
